import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import Button, {
  buttonTypes,
  buttonSizes,
  buttonFunctions,
  buttonTextSizes,
} from '../../shared/Button';
import InlineHelpText from '../../shared/InlineHelpText';
import {
  submitText,
  cancelText,
  noStatusText,
  titleText,
  searchText,
  typeText,
  descriptionText,
  idText,
} from '../../shared/SharedInternationalizations';
import HelpIcon from '../../shared/HelpIcon';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import Table from '../../shared/table/Table';
import { selectorTypes } from '../../shared/table/TableRow';
import SvgXIcon from '../../svg/XIcon';
import SvgExclamationPointIcon from '../../svg/ExclamationPointIcon';
import SvgCheckMarkIcon from '../../svg/CheckMarkIcon';
import Overlay from '../../shared/Overlay';
import { Condition } from '../../shared/Condition';
import AccessControl from '../../../AccessControl';
import permissions from '../../../permissionsList';

export function UnconnectedUserCheckinPreferencesForm(props) {
  const {
    user,
    onSubmit,
    userStatuses,
    checkinModes,
    language,
    input,
    previous,
    alertDeviceTypes,
    checkinCall = 15,
    unitsObj,
  } = props;
  const checkinModesArr = Object.values(checkinModes);
  // Filter the available modes down to only the ones that are valid for checkin
  const activeCheckinModesArr = checkinModesArr.filter(
    (mode) => mode.active === 1 && mode.checkin === 1
  );

  const devicesArr = user.available_checkin_devices || user.alert_devices || [];
  const [checkinModesFilter, setCheckinModesFilter] = useState('');
  const [devicesSearchFilter, setDevicesSearchFilter] = useState('');

  const formFilter = (event) => {
    const value = event.target.value;
    setCheckinModesFilter(value);
  };
  const devicesFilterSet = (event) => {
    const value = event.target.value;
    setDevicesSearchFilter(value);
  };

  const [
    displayCheckInExclusionStartHelpText,
    setDisplayCheckInExclusionStartHelpText,
  ] = useState(false);
  function toggleDisplayCheckInExclusionStartHelpText(value) {
    setDisplayCheckInExclusionStartHelpText(value);
  }
  const checkInExclusionStartHelpTextRef = useRef();
  const checkInExclusionStartHelpText = (
    <FormattedMessage
      id="userEdit.checkInExclusionStartHelpText"
      defaultMessage="During the time the user is excluded from checking in, this will be their listed status in SARA."
      description="Help text for understanding what the user check-in exclude means."
    />
  );
  const [
    displayCheckInExclusionEndHelpText,
    setDisplayCheckInExclusionEndHelpText,
  ] = useState(false);
  function toggleDisplayCheckInExclusionEndHelpText(value) {
    setDisplayCheckInExclusionEndHelpText(value);
  }
  const checkInExclusionEndHelpTextRef = useRef();
  const checkInExclusionEndHelpText = (
    <FormattedMessage
      id="userEdit.checkInExclusionEndHelpText"
      defaultMessage="After the exclusion period is over, this will be the user's status in SARA."
      description="Help text for understanding what the user check-in exclude means."
    />
  );

  const [
    displayCheckInReminderHelpText,
    setDisplayCheckInReminderHelpText,
  ] = useState(false);
  function toggleDisplayCheckInReminderHelpText(value) {
    setDisplayCheckInReminderHelpText(value);
  }
  const checkInReminderHelpTextRef = useRef();
  const checkInReminderHelpText = (
    <FormattedMessage
      id="userEdit.checkInReminderHelpText"
      defaultMessage="If the user has not yet checked in by 15 minutes before the end of the check-in period, they should be called to check-in."
      description="Help text for understanding what the user check-in exclude means."
    />
  );
  const [displayCheckInCallHelpText, setDisplayCheckInCallHelpText] = useState(
    false
  );
  function toggleDisplayCheckInCallHelpText(value) {
    setDisplayCheckInCallHelpText(value);
  }
  const checkInCallHelpTextRef = useRef();
  const checkInCallHelpText = (
    <FormattedMessage
      id="userEdit.checkInCallHelpText"
      defaultMessage="Some users need to be proactively contacted for checking in. Setting this option will trigger a reminder of when to reach out to them for check-in."
      description="Help text for understanding what the user check-in exclude means."
    />
  );

  const [showCheckInExcludeHelpText, setShowCheckInExcludeHelpText] = useState(
    false
  );
  function toggleShowCheckInExcludeHelpText(value) {
    setShowCheckInExcludeHelpText(value);
  }
  const checkInExcludeHelpTextRef = useRef();
  const checkInExcludeHelpText = (
    <FormattedMessage
      id="userEdit.checkInExcludeHelpText"
      defaultMessage="During this time-frame, the user will not be required to check-in. There will be no check-in prompts or alerts. This is used for when a user is going to be away from a location where checking-in would be required, such as in another facility."
      description="Help text for understanding what the user check-in exclude means."
    />
  );

  const [showSelectedDeviceHelpText, setShowSelectedDeviceHelpText] = useState(
    false
  );
  function toggleSelectedDeviceHelpText(value) {
    setShowSelectedDeviceHelpText(value);
  }
  const selectedDeviceHelpTextRef = useRef();

  const [showSelectedModesHelpText, setShowSelectedModesHelpText] = useState(
    false
  );
  function toggleSelectedModesHelpText(value) {
    setShowSelectedModesHelpText(value);
  }
  const selectedModesHelpTextRef = useRef();
  const selectedModesHelpText = (
    <FormattedMessage
      id="userCheckinEdit.selectedModesHelpText"
      defaultMessage="These are checkin modes that are selected"
    />
  );
  const checkinModesText = (
    <FormattedMessage
      id="userCheckinEdit.checkinModesText"
      defaultMessage="Select Check-in Modes"
    />
  );
  const devicesText = (
    <FormattedMessage
      id="userCheckinEdit.devicesText"
      defaultMessage="Select Check-in Device"
    />
  );
  const selectedDeviceHelpText = (
    <FormattedMessage
      id="userCheckinEdit.selectedDeviceHelpText"
      defaultMessage="The selected device will be used to contact the user when they need to be contacted for checking in."
    />
  );

  let unitCheckin = false;
  if (
    user &&
    user.active_unit &&
    unitsObj &&
    unitsObj[user.active_unit] &&
    unitsObj[user.active_unit].checkin_profile &&
    unitsObj[user.active_unit].checkin_profile.is_active &&
    unitsObj[user.active_unit].checkin_profile.checkin_modes.length > 0
  ) {
    unitCheckin = true;
  }

  function statusDisplay() {
    const statusDisplay = userStatuses.map((status, index) => {
      return (
        <option value={status.id} key={index}>
          {status.description}
        </option>
      );
    });

    statusDisplay.unshift(
      <FormattedMessage
        id="userCheckinEdit.selectModeText"
        defaultMessage="<b>- Please select a value -</b>"
        key="blank"
        values={{
          b: (msg) => <option>{msg}</option>,
        }}
      />
    );

    return statusDisplay;
  }

  /**
   * Function to generate the users table
   * @returns {object} - The table of users
   */
  const checkinModesTable = (values) => {
    const initialFilterList = activeCheckinModesArr.filter((mode) => {
      if (values.checkin_modes.includes(mode.mode_num)) {
        return false;
      } else {
        return true;
      }
    });

    const modesArray = initialFilterList.map((mode) => {
      return {
        selector: {
          sortBy: mode.mode_num,
          display: mode.mode_num,
        },
        title: {
          sortBy: mode.mode_name.toUpperCase(),
          display: mode.mode_name,
        },
      };
    });

    let searchedModes = [];
    // Take the array and filter based on the text entered in the search bar.
    if (checkinModesFilter !== '') {
      searchedModes = modesArray.filter((item) => {
        let filterResult = false;
        // Make the device name uppercase for case insensitivity
        const title = item.title.display.toUpperCase();

        const id = item.title.display;
        // filter based off the includes() value with the entered text (also switched to uppercase) as the filter parameter
        if (
          title.includes(checkinModesFilter.toUpperCase()) ||
          checkinModesFilter.includes(id)
        ) {
          filterResult = true;
        }
        return filterResult;
      });
    } else {
      searchedModes = modesArray;
    }

    const tableHeadings = [
      {
        isSortable: false,
        display: '',
      },
      {
        isSortable: true,
        sortBy: 'title',
        display: titleText,
      },
    ];
    // generates the actual table
    const table = (
      <AccessControl feature={permissions.static.users.editUserCheckinProfile}>
      <Table
        hasTableHead={true}
        hasSelector={true}
        tableHeadings={tableHeadings}
        selectorName="checkin_modes"
        selectorParamValue="checkin_modes"
        sortParam="title"
        tableData={searchedModes}
        selectorType={selectorTypes.checkbox}
        tableStyles="table__constrained table-layout__1-column--selector"
        data-test="modes-table"
      />
      </AccessControl>
    );

    return table;
  };

  /**
   * Function to generate the parent unit table
   * @returns {object} - The table of parent units
   */
  const selectedCheckinModesTable = (values) => {
    let table;
    let selectedModes = values.checkin_modes;

    let modesRows;
    if (selectedModes.length > 0) {
      if (selectedModes) {
        const filteredModes = [];
        selectedModes.map((id) => {
          let thisId = id;
          if (typeof id === 'string') {
            thisId = parseInt(thisId);
          }
          if (checkinModes[thisId]) {
            filteredModes.push(checkinModes[thisId]);
          }
          return '';
        });
        modesRows = filteredModes.map((d) => {
          const removeButton = (
            <label>
              <Field
                className="visually-hidden"
                name="checkin_modes"
                component="input"
                type="checkbox"
                value={d.mode_num}
              />
              <SvgXIcon />
            </label>
          );

          return {
            selector: {
              sortBy: '',
              display: removeButton,
            },

            title: {
              sortBy: d.mode_name.toUpperCase(),
              display: d.mode_name,
            },
          };
        });
      }

      const tableHeadings = [
        {
          isSortable: false,
          display: '',
        },
        {
          isSortable: true,
          sortBy: 'title',
          display: titleText,
        },
      ];
      // generates the actual table
      table = (

        <Table
          hasTableHead={true}
          hasSelector={false}
          tableHeadings={tableHeadings}
          sortParam="title"
          tableData={modesRows}
          tableStyles="table__constrained table-layout__1-column--selector"
          data-test="selected-modes-table"
        />
      );

      return table;
    } else {
      return '';
    }
  };

  /**
   * Function to generate the users table
   * @returns {object} - The table of users
   */
  const devicesTable = (values) => {
    const deviceCheck = devicesArr.filter((d) => {
      if (
        d.alert_device_type !== 3 &&
        d.alert_device_type !== 33 &&
        d.alert_device_type !== 24
      ) {
        return false;
      } else {
        return true;
      }
    });
    if (deviceCheck.length > 0) {
      // map over the users and put into the format that is required for the table component
      const initialFilterList = devicesArr.filter((d) => {
        let deviceId = values.checkin_device;
        if (typeof deviceId === 'string') {
          deviceId = parseInt(deviceId);
        }
        if (deviceId === d.alert_device_id) {
          return false;
        } else if (
          d.alert_device_type !== 3 &&
          d.alert_device_type !== 33 &&
          d.alert_device_type !== 24
        ) {
          return false;
        } else {
          return true;
        }
      });

      const devicesArray = initialFilterList.map((d) => {
        let deviceType = '';
        if (alertDeviceTypes[d.alert_device_type]) {
          deviceType = alertDeviceTypes[d.alert_device_type].description;
        }
        return {
          selector: {
            sortBy: d.alert_device_id,
            display: d.alert_device_id,
          },
          id: {
            sortBy: d.alert_device_id,
            display: d.alert_device_id,
          },
          description: {
            sortBy: d.alert_description.toUpperCase(),
            display: d.alert_description,
          },
          type: {
            sortBy: deviceType.toUpperCase(),
            display: deviceType,
          },
        };
      });

      let searchedDevices = [];
      // Take the array and filter based on the text entered in the search bar.

      if (devicesSearchFilter !== '') {
        searchedDevices = devicesArray.filter((item) => {
          let filterResult = false;
          // Make the device name uppercase for case insensitivity
          const description = item.description.display.toUpperCase();
          const type = item.type.display.toUpperCase();
          const id = item.id.display;
          // filter based off the includes() value with the entered text (also switched to uppercase) as the filter parameter
          if (
            description.includes(devicesSearchFilter.toUpperCase()) ||
            devicesSearchFilter.includes(id) ||
            type.includes(devicesSearchFilter.toUpperCase())
          ) {
            filterResult = true;
          }
          return filterResult;
        });
      } else {
        searchedDevices = devicesArray;
      }

      const tableHeadings = [
        {
          isSortable: false,
          display: '',
        },
        {
          isSortable: true,
          sortBy: 'id',
          display: idText,
        },
        {
          isSortable: true,
          sortBy: 'description',
          display: descriptionText,
        },
        {
          isSortable: true,
          sortBy: 'type',
          display: typeText,
        },
      ];
      // generates the actual table
      const table = (
        <AccessControl feature={permissions.static.users.editUserCheckinProfile}>
        <Table
          hasTableHead={true}
          hasSelector={true}
          tableHeadings={tableHeadings}
          selectorName="checkin_device"
          selectorParamValue="checkin_device"
          sortParam="id"
          tableData={searchedDevices}
          selectorType={selectorTypes.radio}
          tableStyles="table__constrained table-layout__3-column--selector"
          data-test="checkin-devices-table"
        />
        </AccessControl>
      );

      return (
        <React.Fragment>
          <div className="content-display__column">
            <div className="form__item-container">
              <div className="align-center">
                <label
                  className="text-medium text-bold form-item__field-message--required"
                  htmlFor="usersId">
                  {devicesText}
                </label>
                <HelpIcon
                  onClick={() =>
                    selectedDeviceHelpTextRef.current.toggleHelpText()
                  }
                  toggled={showSelectedDeviceHelpText}
                  styles="margin-left-5"
                />
              </div>
            </div>
          </div>
          <div className="width-100 margin-bottom-10">
            <InlineHelpText
              ref={selectedDeviceHelpTextRef}
              toggleFunction={toggleSelectedDeviceHelpText}
              message={selectedDeviceHelpText}
            />
          </div>
          <div className="content-display__column">
            {selectedDevicesTable(values)}

            <div className="table__header padding-10">
              <AccessControl feature={permissions.static.users.editUserCheckinProfile}>
              <label className="text-medium text-bold" htmlFor="usersFilter">
                {searchText}:
              </label>
             
              <input
                type="text"
                id="devicesFilter"
                name="devicesFilter"
                onChange={devicesFilterSet}
                className="message-table__filter-search-box margin-left-10"
                value={devicesSearchFilter}
              />
               </AccessControl>
            </div>

            {table}
          </div>
        </React.Fragment>
      );
    } else {
      return '';
    }
  };

  /**
   * Function to generate the parent unit table
   * @returns {object} - The table of parent units
   */
  const selectedDevicesTable = (values) => {
    let table;
    let deviceId = values.checkin_device;
    if (deviceId) {
      if (typeof deviceId === 'string') {
        deviceId = parseInt(deviceId);
      }
      const filteredDevice = devicesArr.filter(
        (dev) => dev.alert_device_id === deviceId
      );

      const deviceRows = filteredDevice.map((d) => {
        const removeButton = (
          <label>
            <AccessControl feature={permissions.static.users.editUserCheckinProfile}>
            <Field
              className="visually-hidden"
              name="checkin_device"
              component="input"
              type="radio"
              value={''}
            />
            </AccessControl>
            <SvgXIcon />
          </label>
        );
        let deviceType = '';
        if (alertDeviceTypes[d.alert_device_type]) {
          deviceType = alertDeviceTypes[d.alert_device_type].description;
        }

        return {
          button: {
            sortBy: '',
            display: removeButton,
          },
          id: {
            sortBy: d.alert_device_id,
            display: d.alert_device_id,
          },
          description: {
            sortBy: d.alert_description.toUpperCase(),
            display: d.alert_description,
          },
          type: {
            sortBy: deviceType.toUpperCase(),
            display: deviceType,
          },
        };
      });

      const tableHeadings = [
        {
          isSortable: false,
          display: '',
        },
        {
          isSortable: false,
          sortBy: 'id',
          display: idText,
        },
        {
          isSortable: false,
          sortBy: 'description',
          display: descriptionText,
        },
        {
          isSortable: false,
          sortBy: 'type',
          display: typeText,
        },
      ];
      // generates the actual table
      table = (
        <Table
          hasTableHead={true}
          hasSelector={false}
          tableHeadings={tableHeadings}
          sortParam="id"
          tableData={deviceRows}
          tableStyles="table__constrained table-layout__3-column--selector"
          data-test="selected-checkin-devices-table"
        />
      );

      return table;
    } else {
      return '';
    }
  };

  const [showCheck, setShowCheck] = useState(false);
  function noModeConfirmation() {
    setShowCheck(true);
  }

  function cancelNoMode() {
    setShowCheck(false);
  }

  /**
   * Function to display the archive challenge notification modal
   */
  function displayNoMode() {
    if (showCheck) {
      if (unitCheckin) {
        return (
          <Overlay
            rootUrl={`/users/view/${user.id}/edit/?mode=checkInPreferences`}
            canClose={false}
            data-test="unit-archive-challenge-overlay"
            useFunction={true}
            onClick={cancelNoMode}>
            <div
              className="content-container content-container--column"
              data-test="archive-overlay">
              <h1 className="no-margin">
                <FormattedMessage
                  id="userCheckinPreferencesForm.unitCheckinChallenge"
                  defaultMessage="This user is being checked in by their active unit."
                  description="The parent unit of the unit being created"
                />
              </h1>

              <hr />

              <React.Fragment>
                <span className="text-alert text-bold">
                  <FormattedMessage
                    id="userCheckinPreferencesForm.unitCheckinChallengeText"
                    defaultMessage="This user does not have a check-in mode assigned so the check-in profile is not active. Because this user's active unit is checking them in, the check-in exclusion settings will be used for excluding the user from checking-in if they are set."
                    description="The parent unit of the unit being created"
                  />
                </span>
                <hr />
              </React.Fragment>

              <div className="flex-end width-100">
                <Button
                  data-test="cancel-archive"
                  onClick={cancelNoMode}
                  text={cancelText}
                  buttonType={buttonTypes.noButton}
                  buttonSize={buttonSizes.small}
                  buttonTextSize={buttonTextSizes.mediumSmall}
                  additionalStyles="no-margin margin-right-15 js-cancel-archive-button"
                />
                <Button
                  data-test="submit-archive"
                  buttonFunction={buttonFunctions.submit}
                  text={submitText}
                  buttonType={buttonTypes.danger}
                  buttonSize={buttonSizes.small}
                  buttonTextSize={buttonTextSizes.mediumSmall}
                  additionalStyles="no-margin  js-submit-archive-button"
                />
              </div>
            </div>
          </Overlay>
        );
      } else {
        return (
          <Overlay
            rootUrl={`/users/view/${user.id}/edit/?mode=checkInPreferences`}
            canClose={false}
            data-test="unit-archive-challenge-overlay"
            useFunction={true}
            onClick={cancelNoMode}>
            <div
              className="content-container content-container--column"
              data-test="archive-overlay">
              <h1 className="no-margin">
                <FormattedMessage
                  id="userCheckinPreferencesForm.noModeChallenge"
                  defaultMessage="There are no check-in modes selected."
                  description="The parent unit of the unit being created"
                />
              </h1>

              <hr />

              <React.Fragment>
                <span className="text-alert text-bold">
                  <FormattedMessage
                    id="userCheckinPreferencesForm.noModeChallengeText"
                    defaultMessage="To use check-in features, there must be a check-in mode selected. If the check-in profile is saved without a check-in mode, it will be inactive."
                    description="The parent unit of the unit being created"
                  />
                </span>
                <hr />
              </React.Fragment>

              <div className="flex-end width-100">
                <Button
                  data-test="cancel-archive"
                  onClick={cancelNoMode}
                  text={cancelText}
                  buttonType={buttonTypes.noButton}
                  buttonSize={buttonSizes.small}
                  buttonTextSize={buttonTextSizes.mediumSmall}
                  additionalStyles="no-margin margin-right-15 js-cancel-archive-button"
                />
                <Button
                  data-test="submit-archive"
                  buttonFunction={buttonFunctions.submit}
                  text={submitText}
                  buttonType={buttonTypes.danger}
                  buttonSize={buttonSizes.small}
                  buttonTextSize={buttonTextSizes.mediumSmall}
                  additionalStyles="no-margin  js-submit-archive-button"
                />
              </div>
            </div>
          </Overlay>
        );
      }
    } else {
      return '';
    }
  }

  //setup some variables to be used for checking exclusion dates
  //create one for today and tomorrow
  const pref = user && user.checkin_profile ? user.checkin_profile : null;
  const today = new Date();
  today.setMinutes(0);
  today.setHours(0);
  today.setSeconds(0);
  let tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setMinutes(0);
  tomorrow.setHours(0);
  tomorrow.setSeconds(0);
  let userInfo = {
    show_panic_buttons: false,
    user: user ? user.id : null,
    exclusion_start_time: tomorrow,
    exclusion_end_time: tomorrow,
    checkin_modes: [],
  };

  if (pref && Object.keys(pref).length > 0) {
    let checkinExclude = false;

    if (pref.exclusion_end_time) {
      const excEnd = new Date(pref.exclusion_end_time);
      // Handle both string format (YYYY-MM-DD) and Date objects
      if (typeof pref.exclusion_end_time === 'string') {
        const exclEndTimeLocal = pref.exclusion_end_time.split('-');
        excEnd.setFullYear(exclEndTimeLocal[0]);
        excEnd.setMonth(exclEndTimeLocal[1] - 1);
        excEnd.setDate(exclEndTimeLocal[2]);
      }

      if (excEnd >= today) {
        checkinExclude = true;
      }
    }

    let exclusionStartTime = tomorrow;
    let exclusionEndTime = tomorrow;
    if (pref.exclusion_start_time) {
      let startTime = new Date();
      // Handle both string format (YYYY-MM-DD) and Date objects
      if (typeof pref.exclusion_start_time === 'string') {
        const exclStartTimeLocal = pref.exclusion_start_time.split('-');
        startTime.setFullYear(exclStartTimeLocal[0]);
        startTime.setMonth(exclStartTimeLocal[1] - 1);
        startTime.setDate(exclStartTimeLocal[2]);
      } else if (pref.exclusion_start_time instanceof Date) {
        startTime = new Date(pref.exclusion_start_time);
      }
      if (startTime >= exclusionStartTime) {
        exclusionStartTime = startTime;
      }
    }
    if (pref.exclusion_end_time) {
      let endTime = new Date();
      // Handle both string format (YYYY-MM-DD) and Date objects
      if (typeof pref.exclusion_end_time === 'string') {
        const exclEndTimeLocal = pref.exclusion_end_time.split('-');
        endTime.setFullYear(exclEndTimeLocal[0]);
        endTime.setMonth(exclEndTimeLocal[1] - 1);
        endTime.setDate(exclEndTimeLocal[2]);
      } else if (pref.exclusion_end_time instanceof Date) {
        endTime = new Date(pref.exclusion_end_time);
      }
      if (endTime >= exclusionStartTime) {
        exclusionEndTime = endTime;
      }
    }

    userInfo = {
      user: pref.user,
      receive_checkin_reminder: pref.receive_checkin_reminder,
      call_for_checkin: pref.call_for_checkin,
      call_for_checkin_time: pref.call_for_checkin_time,
      exclusion_start_time: exclusionStartTime,
      exclusion_end_time: exclusionEndTime,
      exclusion_start_status: pref.exclusion_start_status,
      exclusion_end_status: pref.exclusion_end_status,
      checkinExclude: checkinExclude,
      checkin_modes: pref.checkin_modes,
      checkin_device: pref.checkin_device,
    };
  }

  // Form validation function
  const validateForm = (values) => {
    const errors = {};
    
    // If check-in exclusion is enabled, both dates must be provided
    if (values.checkinExclude) {
      if (!values.exclusion_start_time || values.exclusion_start_time.toString() === 'Invalid Date') {
        errors.exclusion_start_time = 'Start date is required';
      }
      if (!values.exclusion_end_time || values.exclusion_end_time.toString() === 'Invalid Date') {
        errors.exclusion_end_time = 'End date is required';
      }
    }
    
    return errors;
  };

  return (
    <div className="content-display__container">
      <Form
        data-test="user-checkin-preferences-form"
        onSubmit={onSubmit}
        keepDirtyOnReinitialize={true}
        initialValues={{
          ...userInfo,
        }}
        validate={validateForm}
        render={({
          handleSubmit,
          pristine,
          invalid,
          reset,
          submitting,
          values,
          errors,
        }) => (
          <form onSubmit={handleSubmit} className="width-100">
            {displayNoMode()}
            {unitCheckin ||
            values.checkin_modes.length === 0 ||
            activeCheckinModesArr.length === 0 ||
            devicesArr.length === 0 ? (
              <div className="content-display__column">
                <details
                  open={true}
                  className="content-display__item-pill-container content-display-info__info-stacked">
                  <summary className="text-medium text-bold text-deep-blue cursor-pointer">
                    <FormattedMessage
                      data-test="user-no-checkin-devices-message"
                      id="userCheckinPreferencesForm.importantInformation"
                      defaultMessage="Important Information"
                      description="The check-in instructions"
                    />
                    <span className="text-light text-italic">
                      <FormattedMessage
                        data-test="user-no-checkin-devices-message"
                        id="userCheckinPreferencesForm.showHideMessages"
                        defaultMessage="(Click to show/hide messages)"
                        description="The check-in instructions"
                      />
                    </span>
                  </summary>
                  {unitCheckin ? (
                    <div className="width-100 content-display__item-container">
                      <div className="item-container__info-container">
                        <SvgCheckMarkIcon className="text-success" />
                      </div>
                      <div className="item-container__main-container">
                        <div className="text-large text-light text-success align-center">
                          <FormattedMessage
                            data-test="user-checkin-unit-message"
                            id="userCheckinPreferencesForm.checkinUnit"
                            defaultMessage="This user is being checked-in by their primary unit. You can set individual check-in exclusions below or if you want to include a separate check-in profile, ensure that a check-in mode and at least one phone device is associated with this user."
                            description="The check-in instructions"
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  {values.checkin_modes.length === 0 ||
                  activeCheckinModesArr.length === 0 ? (
                    <div className="width-100 content-display__item-container">
                      <div className="item-container__info-container">
                        <SvgExclamationPointIcon className="text-alert" />
                      </div>
                      <div className="item-container__main-container">
                        <div className="text-large text-light text-alert align-center">
                          <FormattedMessage
                            data-test="user-no-checkin-devices-message"
                            id="userCheckinPreferencesForm.noSelectedModes"
                            defaultMessage="To use check-in features, there must be a check-in mode selected. If the check-in profile is saved without a check-in mode, it will be inactive."
                            description="The check-in instructions"
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  {devicesArr.length === 0 ? (
                    <div className="width-100 content-display__item-container">
                      <div className="item-container__info-container">
                        <SvgExclamationPointIcon className="text-alert" />
                      </div>
                      <div className="item-container__main-container">
                        <div className="text-large text-light text-alert align-center">
                          <FormattedMessage
                            data-test="user-no-checkin-devices-message"
                            id="userCheckinPreferencesForm.noCallForCheckinDevice"
                            defaultMessage="This user is not able to be called for a check-in or called to be reminded to check-in. An associated phone device is required in order to use this functionality."
                            description="The check-in instructions"
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                </details>
              </div>
            ) : (
              ''
            )}
            <Field
              className="visually-hidden"
              name="user"
              component="input"
              type="text"
            />
            <div className="content-display__container">
              {values.checkin_modes.length > 0 ? (
                <React.Fragment>
                  <div className="content-display__column content-display__column">
                    <div className="content-display__item-container">
                      <div className="item-container__main-container">
                        <AccessControl
                          feature={permissions.static.users.editUserCheckinProfile}>
                        <Field
                          name="receive_checkin_reminder"
                          data-test="receive_checkin_reminder"
                          id="receive_checkin_reminder"
                          component="input"
                          type="checkbox"
                          className="visually-hidden"
                          disabled={devicesArr.length === 0}
                        />
                        <label
                          className={
                            devicesArr.length === 0
                              ? 'text-large text-dimmed text-light form-item__field-toggle'
                              : 'text-large text-light text-deep-blue form-item__field-toggle'
                          }
                          htmlFor="receive_checkin_reminder">
                          <FormattedMessage
                            id="addEditUserCheckinPreferencesForm.receiveCheckinReminderText"
                            defaultMessage="Contact this user <b>15</b> minutes before the end of the check-in period if the user has not checked in yet"
                            description="Check-in options"
                            values={{ b: () => checkinCall }}
                          />
                        </label>
                        </AccessControl>
                      </div>
                      
                      <div className="item-container__info-container">
                        <AccessControl
                          feature={permissions.static.users.editUserCheckinProfile}>
                        <HelpIcon
                          styles="margin-left-5 text-large"
                          onClick={() =>
                            checkInReminderHelpTextRef.current.toggleHelpText()
                          }
                          toggled={displayCheckInReminderHelpText}
                        />
                        </AccessControl>
                      </div>
                    </div>
                    <InlineHelpText
                      ref={checkInReminderHelpTextRef}
                      toggleFunction={toggleDisplayCheckInReminderHelpText}
                      message={checkInReminderHelpText}
                    />
                  </div>
                  <div className="content-display__column content-display__column--2-3">
                    <div className="content-display__item-container">
                      <div className="item-container__main-container">
                        <AccessControl
                          feature={permissions.static.users.editUserCheckinProfile}>
                        <Field
                          name="call_for_checkin"
                          data-test="call_for_checkin"
                          id="call_for_checkin"
                          component="input"
                          type="checkbox"
                          className="visually-hidden"
                          disabled={devicesArr.length === 0}
                        />
                        <label
                          className={
                            devicesArr.length === 0
                              ? 'text-large text-dimmed text-light form-item__field-toggle'
                              : 'text-large text-light text-deep-blue form-item__field-toggle'
                          }
                          htmlFor="call_for_checkin">
                          <FormattedMessage
                            id="userCheckinPreferencesForm.callForCheckinText"
                            defaultMessage="Call this user for a daily check-in"
                            description="Check-in options"
                          />
                        </label>
                        </AccessControl>
                      </div>
                      <div className="item-container__info-container">
                        <AccessControl
                          feature={permissions.static.users.editUserCheckinProfile}>
                        <HelpIcon
                          styles="margin-left-5"
                          onClick={() =>
                            checkInCallHelpTextRef.current.toggleHelpText()
                          }
                          toggled={displayCheckInCallHelpText}
                        />
                        </AccessControl>
                      </div>
                    </div>
                    <AccessControl
                      feature={permissions.static.users.editUserCheckinProfile}>
                    <InlineHelpText
                      ref={checkInCallHelpTextRef}
                      toggleFunction={toggleDisplayCheckInCallHelpText}
                      message={checkInCallHelpText}
                    />
                    </AccessControl>
                  </div>

                  <div className="content-display__column content-display__column--1-3">
                    <Condition when="call_for_checkin" is={true}>
                      <div className="content-display__item-container">
                        <div className="item-container__main-container">
                          <label
                            className="text-large text-light text-deep-blue "
                            htmlFor="call_for_checkin">
                              <AccessControl
                                feature={permissions.static.users.editUserCheckinProfile}>
                                <FormattedMessage
                                  id="userCheckinPreferencesForm.callCheckinReminderText"
                                  defaultMessage="Time to call:"
                                  description="Check-in options"
                                />
                              </AccessControl>
                          </label>
                          <AccessControl
                            feature={permissions.static.users.editUserCheckinProfile}>
                          <Field name="call_for_checkin_time">
                            {(props) => (
                              <TimePicker
                                name={props.input.name}
                                onChange={props.input.onChange}
                                disableClock={true}
                                value={props.input.value}
                              />
                            )}
                          </Field>
                          </AccessControl>
                        </div>
                      </div>
                    </Condition>
                  </div>
                </React.Fragment>
              ) : (
                ''
              )}
              {values.checkin_modes.length > 0 || unitCheckin ? (
                <div className="content-display__column content-display__column">
                  <div className="content-display__item-container">
                    <div className="item-container__main-container">
                      <Field
                        name="checkinExclude"
                        data-test="checkinExclude"
                        id="checkinExclude"
                        component="input"
                        type="checkbox"
                        className="visually-hidden"
                      />
                      <label
                        className="text-large text-light text-deep-blue form-item__field-toggle"
                        htmlFor="checkinExclude">
                        <FormattedMessage
                          id="userCheckinPreferencesForm.checkInExcludeText"
                          defaultMessage="Temporarily exclude this user from checking-in"
                          description="Check-in options"
                        />
                      </label>
                    </div>
                    <div className="item-container__info-container">
                      <HelpIcon
                        styles="margin-left-5"
                        onClick={() =>
                          checkInExcludeHelpTextRef.current.toggleHelpText()
                        }
                        toggled={showCheckInExcludeHelpText}
                      />
                    </div>
                  </div>
                  <InlineHelpText
                    ref={checkInExcludeHelpTextRef}
                    toggleFunction={toggleShowCheckInExcludeHelpText}
                    message={checkInExcludeHelpText}
                  />
                </div>
              ) : (
                ''
              )}
              <Condition when="checkinExclude" is={true}>
                <div className="content-display__column content-display__column--2-3">
                  <div className="content-display__item-container">
                    <div className="item-container__main-container">
                      <label
                        className="text-large text-light text-deep-blue"
                        htmlFor="exclusion_start_status">
                        <FormattedMessage
                          id="userCheckinPreferencesForm.exclusionStartStatus"
                          defaultMessage="The user's status when excluded from checking in:"
                          description="The state of the unit being created"
                        />
                      </label>
                      <Field
                        className="form-item__field"
                        name="exclusion_start_status"
                        component="select">
                        {noStatusText}
                        {statusDisplay()}
                      </Field>
                    </div>
                    <div className="item-container__info-container">
                      <HelpIcon
                        onClick={() =>
                          checkInExclusionStartHelpTextRef.current.toggleHelpText()
                        }
                        toggled={displayCheckInExclusionStartHelpText}
                        styles="margin-left-5 text-large"
                      />
                    </div>
                  </div>
                  <InlineHelpText
                    ref={checkInExclusionStartHelpTextRef}
                    toggleFunction={toggleDisplayCheckInExclusionStartHelpText}
                    message={checkInExclusionStartHelpText}
                  />
                </div>
                <div className="content-display__column content-display__column--1-3">
                  <div className="content-display__item-container">
                    <div className="item-container__main-container">
                      <label
                        className="text-large text-light text-deep-blue"
                        htmlFor="exclusion_start_time">
                        <FormattedMessage
                          id="userCheckinPreferencesForm.exclusionStartTimeText"
                          defaultMessage="Start Date:"
                          description=""
                        />
                      </label>
                      <Field name="exclusion_start_time">
                        {(props) => {
                          const isValidDate = props.input.value && props.input.value.toString() !== 'Invalid Date';
                          const hasError = errors.exclusion_start_time;
                          return (
                            <>
                              <DatePicker
                                selected={isValidDate ? new Date(props.input.value) : null}
                                name={props.input.name}
                                onChange={props.input.onChange}
                                minDate={tomorrow}
                                dateFormat="yyyy-MM-dd"
                                placeholderText="Select a date"
                                className={hasError ? 'input-error' : ''}
                              />
                              {!isValidDate && props.input.value && (
                                <div className="text-alert text-small margin-top-5">
                                  <FormattedMessage
                                    id="userCheckinPreferencesForm.invalidStartDate"
                                    defaultMessage="Please enter a valid start date"
                                    description="Error message for invalid start date"
                                  />
                                </div>
                              )}
                              {hasError && (
                                <div className="text-alert text-small margin-top-5">
                                  {hasError}
                                </div>
                              )}
                            </>
                          );
                        }}
                      </Field>
                    </div>
                  </div>
                </div>
                <div className="content-display__column content-display__column--2-3">
                  <div className="content-display__item-container">
                    <div className="item-container__main-container">
                      <label
                        className="text-large text-light text-deep-blue"
                        htmlFor="exclusion_end_status">
                        <FormattedMessage
                          id="userCheckinPreferencesForm.exclusionEndStatus"
                          defaultMessage="The user's status after the exclusion has ended:"
                          description="The state of the unit being created"
                        />
                      </label>
                      <Field
                        className="form-item__field"
                        name="exclusion_end_status"
                        component="select">
                        {noStatusText}
                        {statusDisplay()}
                      </Field>
                    </div>
                    <div className="item-container__info-container">
                      <HelpIcon
                        onClick={() =>
                          checkInExclusionEndHelpTextRef.current.toggleHelpText()
                        }
                        toggled={displayCheckInExclusionEndHelpText}
                        styles="margin-left-5 text-large"
                      />
                    </div>
                  </div>
                  <InlineHelpText
                    ref={checkInExclusionEndHelpTextRef}
                    toggleFunction={toggleDisplayCheckInExclusionEndHelpText}
                    message={checkInExclusionEndHelpText}
                  />
                </div>

                <div className="content-display__column content-display__column--1-3">
                  <div className="content-display__item-container">
                    <div className="item-container__main-container">
                      <label
                        className="text-large text-light text-deep-blue"
                        htmlFor="exclusion_end_time">
                        <FormattedMessage
                          id="userCheckinPreferencesForm.exclusionEndTimeText"
                          defaultMessage="End Date:"
                          description=""
                        />
                      </label>
                      <Field name="exclusion_end_time">
                        {(props) => {
                          const isValidDate = props.input.value && props.input.value.toString() !== 'Invalid Date';
                          const hasError = errors.exclusion_end_time;
                          return (
                            <>
                              <DatePicker
                                selected={isValidDate ? new Date(props.input.value) : null}
                                name={props.input.name}
                                onChange={props.input.onChange}
                                dateFormat="yyyy-MM-dd"
                                placeholderText="Select a date"
                                className={hasError ? 'input-error' : ''}
                                minDate={
                                  values.exclusion_start_time
                                    ? new Date(values.exclusion_start_time)
                                    : tomorrow
                                }
                              />
                              {!isValidDate && props.input.value && (
                                <div className="text-alert text-small margin-top-5">
                                  <FormattedMessage
                                    id="userCheckinPreferencesForm.invalidEndDate"
                                    defaultMessage="Please enter a valid end date"
                                    description="Error message for invalid end date"
                                  />
                                </div>
                              )}
                              {hasError && (
                                <div className="text-alert text-small margin-top-5">
                                  {hasError}
                                </div>
                              )}
                            </>
                          );
                        }}
                      </Field>
                    </div>
                  </div>
                </div>
              </Condition>
              
              {unitCheckin ? (
                <div className="content-display__column">
                  <div className="content-display__item-pill-container">
                    <div className="item-container__info-container">
                      <SvgCheckMarkIcon className="text-success" />
                    </div>
                    <div className="item-container__main-container">
                      <div className="text-large text-light text-success align-center">
                        <FormattedMessage
                          id="userCheckinPreferencesForm.unitCheckinModes"
                          defaultMessage="This user will be checked in by their primary unit. Please check the Unit for the Check-in Mode."
                          description="Message shown when unit handles check-in"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ) : activeCheckinModesArr.length > 0 ? (
                <React.Fragment>
                  <div className="content-display__column">
                    <div className="form__item-container">
                      <div className="align-center">
                        <AccessControl
                        feature={permissions.static.users.editUserCheckinProfile}>
                        <label
                          className="text-medium text-bold"
                          htmlFor="usersId">
                          {checkinModesText}
                        </label>
                        <HelpIcon
                          onClick={() =>
                            selectedModesHelpTextRef.current.toggleHelpText()
                          }
                          toggled={showSelectedModesHelpText}
                          styles="margin-left-5"
                        />
                        </AccessControl>
                      </div>
                    </div>
                  </div>
                  <div className="width-100 margin-bottom-10">
                    <InlineHelpText
                      ref={selectedModesHelpTextRef}
                      toggleFunction={toggleSelectedModesHelpText}
                      message={selectedModesHelpText}
                    />
                  </div>
                  <div className="content-display__column">
                    {selectedCheckinModesTable(values)}

                    <div className="table__header padding-10">
                      <AccessControl
                        feature={permissions.static.users.editUserCheckinProfile}>
                      <label
                        className="text-medium text-bold"
                        htmlFor="modesFilter">
                        {searchText}:
                      </label>

                      <input
                        type="text"
                        id="modesFilter"
                        name="modesFilter"
                        onChange={formFilter}
                        className="message-table__filter-search-box margin-left-10"
                        value={checkinModesFilter}
                      />
                      </AccessControl>
                    </div>
                    {checkinModesTable(values)}
                  </div>
                </React.Fragment>  
              ) : (
                <div className="content-display__column">
                  <div className="content-display__item-pill-container">
                    <div className="item-container__info-container">
                      <SvgExclamationPointIcon className="text-alert" />
                    </div>
                    <div className="item-container__main-container">
                      <div className="text-large text-light text-alert align-center">
                        <FormattedMessage
                          data-test="user-no-checkin-devices-message"
                          id="userCheckinPreferencesForm.noModes"
                          defaultMessage="No check-in modes are available to be assigned."
                          description="The check-in instructions"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                
              )}
              {values.receive_checkin_reminder || values.call_for_checkin
                ? devicesTable(values)
                : ''}

              <div className="width-100 margin-bottom-10">
                <hr />
                <div className="form__section-container form__section-container--spread">
                  <div className="form__items-group-container">
                    <Link
                      className="link link-text"
                      to={previous}
                      data-test="user-checkin-preferences-form-cancel-link">
                      {cancelText}
                    </Link>
                  </div>
                  <div className="form__items-group-container">
                    {values.checkin_modes.length === 0 ? (
                      <Button
                        onClick={noModeConfirmation}
                        text={submitText}
                        buttonType={buttonTypes.success}
                        buttonSize={buttonSizes.small}
                        additionalStyles={'no-margin margin-left-15'}
                        disabled={
                          // No I don't like this either, but every other way I found to add this logic in wasn't being checked when the form is used so this was the only way I found to have the logic in place and checking every time anything is touched on the form.
                          invalid ||
                          (values.call_for_checkin
                            ? values.call_for_checkin_time
                              ? false
                              : true
                            : false) ||
                          (values.call_for_checkin ||
                          values.receive_checkin_reminder
                            ? values.checkin_modes.length > 0 &&
                              values.checkin_device
                              ? false
                              : true
                            : false)
                        }
                      />
                    ) : (
                      <Button
                        buttonFunction={buttonFunctions.submit}
                        text={submitText}
                        buttonType={buttonTypes.success}
                        buttonSize={buttonSizes.small}
                        additionalStyles={'no-margin margin-left-15'}
                        disabled={
                          // No I don't like this either, but every other way I found to add this logic in wasn't being checked when the form is used so this was the only way I found to have the logic in place and checking every time anything is touched on the form.
                          invalid ||
                          (values.call_for_checkin
                            ? values.call_for_checkin_time
                              ? false
                              : true
                            : false) ||
                          (values.call_for_checkin ||
                          values.receive_checkin_reminder
                            ? values.checkin_modes.length > 0 &&
                              values.checkin_device
                              ? false
                              : true
                            : false)
                        }
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
        )}
      />
    </div>
  );
}
const mapStateToProps = (state, ownProps) => {
  const userStatuses = Object.values(state.users.userStatuses);

  return {
    userStatuses,
    checkinModes: state.users.checkinModes,
    alertDeviceTypes: state.devices.alertDeviceTypes,
    devices: state.devices.alertDeviceDetails,
    checkinCall: state.system.siteInfo.checkin_reminder_time,
    unitsObj: state.units.units,
  };
};

export default connect(mapStateToProps)(UnconnectedUserCheckinPreferencesForm);
